import Vue from 'vue'
import vuex from 'vuex'

Vue.use(vuex)

const store = new vuex.Store({
  state: {
    systemUser: null,
    contentWidth: 0,
    contentHeith: 0,
    currentPatient: {}
  },
  getters : {
    getSystemUserName(state) {
        return state.systemUser.name
    },
      getCurrentPatient(state) {
          return state.currentPatient
      },
  },
  mutations: {
    setSystemUser(state,systemUser) {
        state.systemUser = systemUser
    },
      setCurrentPatient (state, currentPatient) {
          state.currentPatient = currentPatient
      },
    setContentWidth (state, contentWidth) {
      state.contentWidth = contentWidth
    },
    setContentHeith (state, contentHeith) {
      state.contentHeith = contentHeith
    }
  }
})

export default store;
